<template>
	<div>
		<div class="directory-card-wrapper d-flex align-center mb-4">
			<div
				v-if='customFlag'
				:style='{backgroundColor: customFlagColor}'
				class="directory-preview-card__pin"
			>
				<span :style='{backgroundColor: customFlagColor}'>
					{{customFlagName}}
					<span :style='{backgroundColor: customFlagColor}'></span>
				</span>
			</div>

			<Avatar
				class="mr-8 post-preview-card__avatar"
				ize="85"
				:avatar="logo"
			/>

			<div>
				<div
					v-if='name'
					class="directory-card-title mb-2"
				>
					{{ name }}
				</div>
				<div
					v-if='company'
					class="directory-card-description mb-2"
				>
					{{ company }}
				</div>
				<div
					v-if='thirdRow'
					class="directory-card-description mb-2"
				>
					{{ thirdRow }}
				</div>
				<div
					v-if='forthRow'
					class="directory-card-location d-flex align-center mb-2"
				>
					<Icon
						type='pin'
                        color='var(--company-position-large)'
                        :size='16'
						:pr="4"
					/>
					{{ forthRow }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Avatar from '@/components/Avatar'

Vue.use(VueScrollTo)

export default {
	name: 'DirectoryCard',

	components: {
		Avatar,
	},
	props: {
		directory: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		customFlag() {
			const {custom_flag: value} = this.directory || {};
			return value;
		},
		customFlagColor() {
			const {custom_flag_color: value} = this.directory || {};
			return value;
		},
		customFlagName() {
			const {custom_flag_name: value} = this.directory || {};
			return value;
		},
		logo() {
			const {directory_logo: logo} = this.directory || {};

			return logo;
		},
		company() {
			const {
				directory_second_row: company
			} = this.directory || {};

			return company
		},
		name() {
			const {
				directory_first_row: firstName
			} = this.directory || {};

			return `${firstName}`;
		},
		thirdRow() {
			const {directory_third_row: row} = this.directory || {};

			return row;
		},
		forthRow() {
			const {directory_forth_row: row} = this.directory || {};

			return row;
		}
	}
}
</script>

<style lang="scss">
.directory-preview-card {
	&__pin {
		text-align: right;
		position: absolute;
		border-radius: 12px;
		top: 0;
		right: 0;

		span {
			z-index: 0;
			position: relative;
			background: var(--accent-color);
			display: inline-flex;
			padding: 5px 10px 5px 10px;
			border-top-right-radius: 8px;
			color: rgb(255, 255, 255);
			font-size: 12px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
		}

		// Start
		span {
			span {
				z-index: -1;
				content: '';
				position: absolute;
				left: -17%;
				top: 0;
				height: 100%;
				width: 100%;
				-webkit-transform: skewX(20deg);
				-moz-transform: skewX(20deg);
				-ms-transform: skewX(20deg);
				transform: skewX(20deg);
			}
		}
	}
}

.directory-card {
	&-wrapper {
		display: flex;
		position: relative;
		background: rgb(251, 251, 251);
		border: 1px solid rgb(226, 226, 226);
		border-radius: 12px;
		padding: 24px 32px;

		@media (max-width: 768px) {
			padding: 28px;
		}
	}

	&-logo {
		width: 25%;
		object-fit: contain;
		margin-right: 10px;
	}
	&-title {
		color: var(--username-category-title);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	&-location {
		display: flex;
		font-size: 13px;
		font-family: Montserrat, sans-serif;
		font-weight: 600;
		letter-spacing: 0;
		line-height: 17px;
		color: var(--company-position-large) !important;
	}
	&-description {
		color: var(--company-position-large);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		line-height: 20px;
	}
}

.location-icon {
	color: var(--accent-color) !important;
}

@media screen and (min-width: 1200px) {
	.directory-card-wrapper {
		max-width: 100%;
		width: 100%;
	}
}

@media screen and (min-width: 1320px) {
	.directory-card-wrapper {
		max-width: 600px;
	}
}
</style>
